export default __webpack_public_path__ + "static/media/box-top.971667a5.webp";